// extracted by mini-css-extract-plugin
export default {"main":"style_main__nlHNj","main_text":"style_main_text__kiqFX","main_buttons":"style_main_buttons__k+ZML","loading":"style_loading__Q4xMm"};